<template>
    <div>
        <div class="return">
            <img @click="back()" src="./../../assets/img/artical/goBack.png" alt="">
            <span>返回</span>
        </div>
        <div class="articalContent wrap">
            <p class="title">{{artical.title}}</p>
            <div class="text" v-html="artical.content">

            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            artical: {
                title: '',
                content: ''
            },
        }
    },

    mounted() {
        window.scrollTo(0,0);
        let articalList = this.$store.state.healthArtical;
        let articalId = this.$store.state.healthArticalId;
        console.log(articalId);
        for (let i = 0; i < articalList.length; i++) {
            if (articalList[i].id == articalId) {
                this.artical = articalList[i];
            }
        }
    },

    methods: {
        back(){
            this.$router.go(-1);
        }
    },

    computed: {
        // articalId: function () {
        //     return this.$store.state.healthArticalId;
        // }
    },

    components: {
    },
}

</script>

<style scoped lang='less'>
@import "./../../assets/css/artical.less";
</style>


// WEBPACK FOOTER //
// src/views/artical/healthContent.vue